import type { StorySection } from '../fr/asterionStory';

/**
 * Original content for /en/asterion — does not exist on solutions-asterion.com,
 * so it can be indexed here without competing with the company site.
 * Person angle: who the author is, not a product catalog.
 */
export const ASTERION_STORY: readonly StorySection[] = [
  {
    id: 'atelier',
    heading: 'It started with an annoyance, not a business idea',
    paragraphs: [
      'I did not start Asterion Solutions because I wanted to build software. I started it because I was losing my days doing things a machine should have been doing for me.',
      'For fourteen years I worked as a mechanical engineering technician on the shop-floor side: dimensional inspection, quality packages, non-conformities, calibration, ISO 9001. Hydro-Québec, GE, Voith, Andritz. Expensive parts, tolerances that forgive nothing, and a report to produce for every one of them.',
      'The technical work I liked. What I could no longer stand was everything around it: keying the same dimension in three times, hunting for a material certificate in a binder, rebuilding by hand a report the system could have generated.',
    ],
  },
  {
    id: 'premier-outil',
    heading: 'I wrote the first tool for myself',
    paragraphs: [
      'I learned to code to fix my own problem. Not to sell it — to stop losing hours. The first tool read the dimensions off a drawing and built the inspection report on its own.',
      'It was not much to look at. But it ran in a real shop, on real parts, against real deadlines. That is the only validation that counts: a tool that survives a day of production has already proven more than any demo.',
      'Then colleagues asked to use it. Then other shops did.',
    ],
  },
  {
    id: 'asterion',
    heading: 'Why Asterion Solutions exists',
    paragraphs: [
      'Asterion Solutions came out of one observation: small and mid-sized manufacturers buy ERP systems designed for companies ten times their size, and end up running the essentials in spreadsheets nobody dares touch.',
      'What is missing is almost never one more large system. It is a dedicated application that does one thing, talks to the ERP already in place, and ships in days rather than quarters.',
      'That is what I build. The full catalog, the available applications and the terms are on the company site.',
    ],
  },
  {
    id: 'pourquoi-deux-sites',
    heading: 'Why two sites',
    paragraphs: [
      'Asterion Solutions is me. There is no sales team behind it, no founder listed on an "about" page.',
      'This site answers one question: who is the person writing this software, and why you should believe him. The company site answers the other: what does it sell, and on what terms.',
      "If you are looking for a business application for your shop, that is where to go. If you'd rather know who you're talking to first, you are in the right place.",
    ],
  },
];
